import { render, staticRenderFns } from "./BaseTradeInSection.vue?vue&type=template&id=e2ac6ddc&scoped=true"
import script from "./BaseTradeInSection.vue?vue&type=script&lang=js"
export * from "./BaseTradeInSection.vue?vue&type=script&lang=js"
import style0 from "./BaseTradeInSection.vue?vue&type=style&index=0&id=e2ac6ddc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ac6ddc",
  null
  
)

export default component.exports